import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import ruralPropertyActivityListAction from './ruralPropertyActivityList.action.json' with { type: 'json' }
import { ruralPropertyActivityObject } from '../ruralPropertyActivityObject'

export const ruralPropertyActivityExpression = expression(ruralPropertyActivityObject.shape)

const ruralPropertyActivityListDefinition = defineAction({
  ...ruralPropertyActivityListAction,

  input: z.object({
    filter: ruralPropertyActivityExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      ruralPropertyId: 'Propriedade rural',
      activityType: 'Tipo de atividade',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(ruralPropertyActivityObject),
    count: z.number(),
  }),
})

export default ruralPropertyActivityListDefinition
